import { render, staticRenderFns } from "./NeededFromCompanies.vue?vue&type=template&id=4604dc02&scoped=true&"
import script from "./NeededFromCompanies.vue?vue&type=script&lang=js&"
export * from "./NeededFromCompanies.vue?vue&type=script&lang=js&"
import style0 from "./NeededFromCompanies.vue?vue&type=style&index=0&id=4604dc02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4604dc02",
  null
  
)

export default component.exports